import React, { createContext } from 'react';
import { noop } from './util';

/**
 * 页面接口定义
 */

interface RESCUE_MESSAGES {
  name: string;
  value: string;
}

/**
 * 页面常量定义
 */

// 高德地图 Key
export const AMAP_KEY: string = "e9c4e1537725c67ae982d59e02c6eca4";
// 高德地图版本号
export const AMAP_VERSION: string = "2.0"; // 1.4.15
export const AMAP_UI_VERSION: string = "1.1";

// 高德地图插件
export const AMAP_PLUGINS: string[] = [
  'AMap.ToolBar',
  'AMap.ControlBar',
  'AMap.Geolocation'
];

export const AMAP_SCRIPT_CALLBACK_NAME = '__amap_init_callback';

export const AMAP_MAIN_SCRIPT_URL = 
  `//webapi.amap.com/maps?v=${AMAP_VERSION}&key=${AMAP_KEY}&callback=${AMAP_SCRIPT_CALLBACK_NAME}&plugin=${AMAP_PLUGINS.join(',')}`

export const AMAP_UI_SCRIPT_URL = 
  `//webapi.amap.com/ui/${AMAP_UI_VERSION}/main-async.js`

interface IContext {
  state: any,
  dispatch: any,
}
// 创建一个上下文
export const Context = createContext<IContext>({
  state: {},
  dispatch: noop
});

export const INIT_STATE = {
  uploadedImageList: {},
  createOrderState: 0
};

// 默认客服号码（配置接口不可用时兜底用）
export const DEFAULT_SERVICE_CALL_NUMBER = '4007836688';

// 文件上传格式
export const ALLOW_IMG_FILE_TYPE = 'jpg, jpeg, png';
export const ALLOW_IMG_FILE_MAX_SIZE = 1024 * 1024 * 10;

export const CATEGORY_LIST = ['FRONT', 'BACK', 'WHEEL'];
// 上传图片分类类型
export const UPLOAD_CATEGORY_TYPE = {
  FRONT: {
    title: '前方45度',
    value: '01'
  },
  BACK: {
    title: '后方',
    value: '02'
  },
  WHEEL: {
    title: '车轮',
    value: '03'
  },
}

// 每个分类最大上传图片数量
export const MAX_UPLOAD_COUNT_PER_CATEGORY = 3;

export const PEOPLE_NUMBER: number[] = [1, 2, 3, 4, 5];
export const RESCUE_REASONS: RESCUE_MESSAGES[] = [
  { name: "轮胎问题", value: "003" },
  { name: "电池没电", value: "002" },
  { name: "车辆故障", value: "005" },
  { name: "交通事故", value: "004" },
];
export const IF_SHIFT_TON: RESCUE_MESSAGES[] = [
  { name: "可以挂N档/解除手刹", value: "1" },
  { name: "无法挂N档/解除手刹", value: "0" },
];
export const IF_TOWBAR: RESCUE_MESSAGES[] = [
  { name: "有", value: "1" },
  { name: "无", value: "0" },
];
export const CAR_POSITIONS: RESCUE_MESSAGES[] = [
  { name: "开阔地面", value: "01" },
  { name: "地下车库", value: "02" },
//   { name: "周围有阻碍的其他地方", value: "03" },
];

export const LOAD_STATUS = {
  NULL: -1, // 未开始
  PENDING: 0, // 请求中。。。
  SUCCESS: 200, // 加载成功
  FAIL: 400, // 加载失败
  ERROR: 404, // 加载异常
  TIMEOUT: 504 // 超时
};

// actions set
export const ACTION_NAME = {
  CREATE_RESCUE_ORDER: 'ACTION_NAME-CREATE_RESCUE_ORDER',
  SET_USER_INFO_DATA: 'ACTION_NAME-SET_USER_INFO_DATA',
  SET_PAGE_CONFIG_DATA: 'ACTION_NAME-SET_PAGE_CONFIG_DATA',
  SET_UPLOAD_IMGS_DATA: 'ACTION_NAME-SET_UPLOAD_IMGS_DATA',
  RESET_FORM_DATA: 'ACTION_NAME-RESET_FORM_DATA'
};

// 工单信息轮询时间间隔
export const ORDER_STATE_INTERVAL_TIME = 60;
// 地图车辆信息轮询时间间隔
export const DRAW_MAP_INTERVAL_TIME = 5;

// 小屏兼容阈值
export const MIN_SCREEN_HEIGHT = 480;

export const RESCUE_STATE_SET = {
  RECEIVED: {
    value: '01',
    title: '救援确认中',
    desc: ''
  },
  CONFIRMED: {
    value: '02',
    title: '救援已确认',
    desc: ''
  },
  COMING: {
    value: '03',
    title: '救援车在途',
    desc: ''
  },
  ARRIVED: {
    value: '04',
    title: '救援到达',
    desc: ''
  }
}

// 异常码枚举集合
export const ERROR_CODE_MAP = {
  NEED_LOGIN: 12150008, // 登录失效异常码，需要提示登录 12150008
  ORDER_REPEAT: 48800024 // 订单重复创建
}

export const COMMON_ERROR_MSG = (
  <div className="common-error-msg">
    网络问题，无法进入线上救援流程，请拨打救援热线：
    <p><a className="phone-call-num" href={`tel:${4007836688}`}>4007836688</a></p>
  </div>
);

export const NEED_LOGIN_ERROR_MSG = (
  <div className="common-error-msg">
    请登录后再使用，救援电话：
    <p><a className="phone-call-num" href={`tel:${4007836688}`}>4007836688</a></p>
  </div>
);
